/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Updated_Refresh_FailedInputs */

const en_app_updated_refresh_failed = /** @type {(inputs: App_Updated_Refresh_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new version is available but the automatic refresh didn't work. Please refresh the page manually.`)
};

const nl_app_updated_refresh_failed = /** @type {(inputs: App_Updated_Refresh_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een nieuwe versie is beschikbaar maar het automatisch vernieuwen is mislukt. Vernieuw de pagina handmatig.`)
};

/**
* | output |
* | --- |
* | "A new version is available but the automatic refresh didn't work. Please refresh the page manually." |
*
* @param {App_Updated_Refresh_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const app_updated_refresh_failed = /** @type {((inputs?: App_Updated_Refresh_FailedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Updated_Refresh_FailedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_app_updated_refresh_failed(inputs)
	return en_app_updated_refresh_failed(inputs)
});